module.exports = __webpack_public_path__ + "img/Turčija.988bf7eb.png";